/**
 * Shared font stacks (CH-07, UI native-feel wave).
 *
 * Every Monaco editor instance, the embedded terminal (xterm), and the
 * Tailwind `--font-sans` / `--font-mono` CSS tokens must agree on the same
 * font family + fallback chain instead of drifting copy-pasted stacks.
 * Backed by the bundled `@fontsource-variable/inter` and
 * `@fontsource-variable/jetbrains-mono` packages, imported once in
 * `src/main.tsx` before any component renders — nothing here works without
 * that import having run.
 *
 * Keep `MONO_FONT_STACK` byte-identical to the `--font-mono` value in
 * `src/index.css` (Tailwind's `@theme` can't reference a TS constant).
 */

export const MONO_FONT_STACK =
  "'JetBrains Mono Variable', 'JetBrains Mono', ui-monospace, Menlo, monospace";
